import BaseComponent from './BaseComponent';
// import Swiper        from 'swiper';
import { throttle }  from 'lodash';

class SliderProductImages extends BaseComponent {
  constructor(componentName, autoInit = true){
    super(componentName);

    this.options = {
      wrapperClass: 'slides-list',
      slideClass: 'slide',
      centeredSlides: true,
      slidesPerView: 'auto',  // Default slides per view
      spaceBetween: 20,
      loop: false,
      navigation: {
        prevEl: '.slider__btn--prev',
        nextEl: '.slider__btn--next'
      },
      pagination: {
        el: '.slider__images-pagination',
        clickable: true,
      },
      speed: 300,
      watchOverflow: true,
      on: {
        init: function () {
          // console.log('swiper initialized');
        },
      }
    };

    const breakpoint = 1200;
    const breakpointUnit = 'px'
    this.pageWidth = window.matchMedia(`(min-width: ${breakpoint}${breakpointUnit})`);

    this.isEnabled;

    this.classElement = `.${componentName}`;
    autoInit ? this.autoInit() : '';
  }


  init(component) {
    this.addCustomEvents(component);
  }


  autoInit() {
    if (!this.pageWidth.matches) {
      this.slider = new Swiper(this.classElement, this.options);
      this.isEnabled = true;
    }
  }

  update() {
    this.slider = new Swiper(this.classElement, this.options);
    this.isEnabled = true;
  }

  addCustomEvents(component) {

    if(!!this.slider && this.slider.slides.length < 2) {
      this.slider.destroy(true, true);
    } else {
      window.addEventListener('resize', _.throttle((e) => {
        if (this.pageWidth.matches) {
          if (!!this.slider) {
            this.slider.destroy(true, true);
            this.slider = undefined;
            this.isEnabled = false;
          }
          return;
        } else {
          if (!this.isEnabled) {
            this.autoInit();
          }
        }
      }, 500));
    }

  }

}

export default SliderProductImages;
